<template>
  <v-container fluid class="px-0 py-0">
    <CorePickPlaceSheetTable
        title=""
        dto-list-query="PickPlaceSheetListQueryDTO"
        :store-name="storeTableName"
        :height="height - 260"
        :detail-store-name="storeDetailName"
        :hide-default-footer="true"
        :hide-default-header="true"
        :show-select="true"
        :main-validator="false"
        :row-background="rowBackground"
    ></CorePickPlaceSheetTable>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreBomDetail from "@/components/CoreComponent/Bom/CoreBomDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import {useDetailStore} from "@/components/Common/CommonDetail";
import CorePickPlaceSheetTable from "@/components/CoreComponent/PickPlaceSheet/CorePickPlaceSheetTable";

export default {
  name: "CoreProductPickPlaceTable",

  props: {
    height: {default: null},
    product_uid: {default: null}
  },

  components: {
    CommonTable,
    CoreBomDetail,
    BaseFieldCheck,
    CorePickPlaceSheetTable,
  },

  watch: {
    product_uid: {
      handler(newValue, oldValue) {
        // console.log('watch BomDetail uidItem', newValue, oldValue)
        this.filterTable()
        this.storeDetail.parentUid = this.product_uid
      },
      deep: true
    },
  },

  methods: {
    rowBackground(item) {
      if (item.import_error_status === 'ERROR')
        return 'red lighten-4'
      if (item.import_error_status === 'WARNING')
        return 'orange lighten-4'
      if (item.import_error_status === 'SUCCESS')
        return 'green lighten-4'
    },
    filterTable() {
      this.storeTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'product__uid', value: this.product_uid, enable: !!this.product_uid},
          {param_compare: 'product__uid', value: null, enable: !this.product_uid},
        ],
        enable: true,
      }
    },
  },


  mounted() {
    this.storeDetail = useDetailStore(this.storeDetailName)()
    this.storeAggregate = useAggregateStore()
    this.storeTable = useTableStore(this.storeTableName)()
    this.storeTable.options.itemsPerPage = -1
    this.storeTable.options.sortBy = ['designator']
    this.storeTable.options.sortDesc = [true]
    this.storeTable.footerProps = {'items-per-page-options': [5, 20, 50, 100, 200, -1]}
    this.filterTable()
  },

  data() {
    return {
      storeDetail: null,
      storeDetailName: uuidv4(),
      storeAggregate: null,
      storeTable: null,
      storeTableName: uuidv4(),
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>